import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import editorConfiguration from "variables/EditorConfiguration";
import Datetime from "react-datetime";
import Constants from "variables/Constants";
import { MultiSelect } from "react-multi-select-component";
const classes = makeStyles(styles);

const fd = new FormData();

//  console.log(selectId)
class UpdateBatch extends Component {
  state = {
    selectId: "",
    type: "",
    batch_name: "",
    description: "",
    googlesheetdetails: "",
    batch_date: "",
    is_validity: "",
    registration_start_date: "",
    registration_end_date: "",
    capacity: "",
    color: "",
    image: [],
    category: "",
    courses: [],
    facultyArr: [],
    showBoth: false,
    catData: [],
    amenities: [],
    amenity: "",
    redirect: false,
    aAlert: false,
    bAlert: false,
    notification: false,
    loading: false,
    attempt: "",
    allAttempts: [],
  };
  componentDidMount() {
    let id = window.location.pathname.split("/")[3];
    this.setState({ selectId: id });
    console.log("hello");
    axios.get(Constants.getUrls.getBatches + "/" + id).then((res) => {
      console.log(res);
      this.setState(
        {
          batch_name:
            res.data.data.batch_name === null ? "" : res.data.data.batch_name,
          description:
            res.data.data.description === null ? "" : res.data.data.description,
          googlesheetdetails:
            res.data.data.google_sheet === null
              ? ""
              : res.data.data.google_sheet,
          batch_date:
            res.data.data.batch_date === null ? "" : res.data.data.batch_date,
          is_validity:
            res.data.data.is_validity === null ? "" : res.data.data.is_validity,
          registration_start_date:
            res.data.data.registration_start_date === null
              ? ""
              : res.data.data.registration_start_date,
          registration_end_date:
            res.data.data.registration_end_date === null
              ? ""
              : res.data.data.registration_end_date,
          capacity:
            res.data.data.capacity === null ? "" : res.data.data.capacity,
          image: res.data.data.image === null ? "" : res.data.data.image,
          color: res.data.data.color === null ? "" : res.data.data.color,
          attempt:
            res.data.data.attempt === null ? "" : res.data.data.attempt.id,
        },
        () => {
          console.log(this.state.attempt);
        }
      );
    });

    axios
      .get("https://admin.akclasses.in/api/attempt")
      .then((resp) => {
        console.log("Attempt Data:", resp.data);

        const attempts = Array.isArray(resp.data.data) ? resp.data.data : [];

        this.setState({
          allAttempts: attempts,
        });
      })
      .catch((error) => {
        console.error("Error fetching attempts:", error);
        this.setState({ allAttempts: [] });
      });
  }
  findFaculty = (data) => {
    let obj = this.state.facultyArr.find((v) => v.id === data[0].faculty_id);
    if (obj !== undefined) {
      return obj.name;
    }
  };
  handleDrop = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
        showBoth: false,
      },
      () => {
        axios
          .get("https://admin.akclasses.in/api/course/" + this.state.type)
          .then((resp) => {
            //console.log(resp.data);
            this.setState({
              catData: resp.data.product.variant,
            });
            let viewIds = [];
            let views = [];
            this.state.catData.forEach((v) => {
              if (viewIds.includes(v.view_and_validity.id) === false) {
                viewIds.push(v.view_and_validity.id);
                views.push(v.view_and_validity);
              }
            });
            //console.log(views);
            this.setState({ catData: views }, () => {
              this.setState({
                showBoth: this.state.catData.length >= 1 ? true : false,
              });
            });
          });
      }
    );
  };

  handleFile = (e) => {
    this.setState({
      image: e.target.files[0],
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    // let payLoad = {
    //   batch_name: this.state.batch_name,
    //   description: this.state.description,
    //   batch_date: this.state.batch_date,
    //   registration_start_date: this.state.registration_start_date,
    //   registration_end_date: this.state.registration_end_date,
    //   capacity: this.state.capacity,
    // };
    // console.log(payLoad);
    this.setState({
      loading: true,
    });
    fd.append("batch_name", this.state.batch_name);
    fd.append("description", this.state.description);
    fd.append("google_sheet", this.state.googlesheetdetails);
    fd.append("batch_date", this.state.batch_date);
    fd.append("is_validity", this.state.is_validity);
    if (this.state.is_validity === "Yes") {
      if (this.state.registration_start_date !== null) {
        fd.append(
          "registration_start_date",
          this.state.registration_start_date
        );
      } else {
        fd.append("registration_start_date", "");
      }

      if (this.state.registration_end_date !== null) {
        fd.append("registration_end_date", this.state.registration_end_date);
      } else {
        fd.append("registration_end_date", "");
      }
    } else {
      fd.append("registration_start_date", "");
      fd.append("registration_end_date", "");
    }
    fd.append("capacity", this.state.capacity);
    fd.append("image", this.state.image);
    fd.append("color", this.state.color);
    fd.append("attempt", this.state.attempt);
    console.log(fd);
    axios
      .post(
        Constants.postUrls.updateBatches + this.state.selectId + "?_method=PUT",
        fd
      )
      .then((resp) => {
        console.log(resp);
        setTimeout(() => {
          this.setState({
            redirect: true,
          });
        }, 1000);
        this.setState({
          notification: true,
          loading: false,
        });
      });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/batches"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Batch Added!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Update Batch</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Batch"
                          id="float"
                          inputProps={{
                            value: this.state.batch_name,
                            required: true,
                            onChange: (e) =>
                              this.setState({ batch_name: e.target.value }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <img
                          src={Constants.imgUrl + this.state.image}
                          style={{ height: "100px", width: "100px" }}
                          // id="upload"
                        />
                        <div>
                          <label>Upload Image</label>
                          <br />
                          <input
                            ref="file"
                            id="image"
                            name="image"
                            onChange={this.handleFile}
                            accept="image/*"
                            type="file"
                            // required={true}
                            style={{ marginTop: "15px" }}
                          />
                        </div>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <label>Select Color</label>
                        <br />
                        <input
                          id="color"
                          name="color"
                          onChange={(e) => {
                            this.setState({ color: e.target.value });
                          }}
                          type="color"
                          required={true}
                          style={{
                            marginTop: "15px",
                            height: "50px",
                            width: "200px",
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          required={true}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Select Attempt
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={
                              this.state.attempt === null
                                ? ""
                                : this.state.attempt
                            }
                            inputProps={{
                              name: "category",
                              id: "simple-select",

                              onChange: (e) => {
                                this.setState(
                                  { attempt: e.target.value },
                                  () => {
                                    console.log(this.state.attempt);
                                  }
                                );
                              },
                            }}
                          >
                            {this.state.allAttempts.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </GridItem>

                      {/* <GridItem xs={12} sm={12} md={6} style={{marginTop:"40px"}}>
                        <div
                          style={{
                            position: "relative",
                            bottom: "11px",
                            border: "none"
                          }}
                        >
                          <label htmlFor="Amenities">Amenities</label>
                          <MultiSelect
                            disableSearch
                            options={this.state.amenities}
                            value={this.state.amenity}
                            onChange={data => {
                              this.setState({ amenity: data });
                            }}
                            labelledBy={"Amenities"}
                          />
                        </div>
                      </GridItem> */}

                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{ marginTop: "40px" }}
                      >
                        <label>Batch Date</label>
                        <FormControl fullWidth>
                          <Datetime
                            value={this.state.batch_date}
                            timeFormat={false}
                            onChange={(e) => {
                              let year = e._d.getFullYear().toString();
                              let month = (e._d.getMonth() + 101)
                                .toString()
                                .substring(1);
                              let day = (e._d.getDate() + 100)
                                .toString()
                                .substring(1);
                              this.setState(
                                {
                                  batch_date: year + "/" + month + "/" + day,
                                },
                                () => {
                                  //console.log(this.state.batch_date);
                                }
                              );
                            }}
                            inputProps={{
                              value: this.state.batch_date,
                              required: true,
                              placeholder: "Batch Date",
                            }}
                          />
                        </FormControl>
                      </GridItem>

                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{ marginTop: "40px" }}
                      >
                        <FormControl
                          style={{ marginTop: "12px" }}
                          required={true}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Show Validity
                          </InputLabel>
                          <Select
                            // key={}
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            value={this.state.is_validity}
                            inputProps={{
                              name: "status",
                              id: "simple-select",
                              onChange: (e) =>
                                this.setState({ is_validity: e.target.value }),
                            }}
                          >
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="Yes"
                            >
                              Yes
                            </MenuItem>
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value="No"
                            >
                              No
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </GridItem>

                      {this.state.is_validity === "Yes" ? (
                        <>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={6}
                            style={{ marginTop: "40px" }}
                          >
                            <label>Registration Start Date</label>
                            <FormControl fullWidth>
                              <Datetime
                                value={this.state.registration_start_date}
                                timeFormat={false}
                                onChange={(e) => {
                                  let year = e._d.getFullYear().toString();
                                  let month = (e._d.getMonth() + 101)
                                    .toString()
                                    .substring(1);
                                  let day = (e._d.getDate() + 100)
                                    .toString()
                                    .substring(1);
                                  this.setState(
                                    {
                                      registration_start_date:
                                        year + "/" + month + "/" + day,
                                    },
                                    () => {
                                      //console.log(this.state.registration_start_date);
                                    }
                                  );
                                }}
                                inputProps={{
                                  value: this.state.registration_start_date,
                                  required: true,
                                  placeholder: "Registration Start Date",
                                }}
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={6}
                            style={{ marginTop: "40px" }}
                          >
                            <label>Registration End Date</label>
                            <FormControl fullWidth>
                              <Datetime
                                value={this.state.registration_end_date}
                                timeFormat={false}
                                onChange={(e) => {
                                  let year = e._d.getFullYear().toString();
                                  let month = (e._d.getMonth() + 101)
                                    .toString()
                                    .substring(1);
                                  let day = (e._d.getDate() + 100)
                                    .toString()
                                    .substring(1);
                                  this.setState(
                                    {
                                      registration_end_date:
                                        year + "/" + month + "/" + day,
                                    },
                                    () => {
                                      //console.log(this.state.registration_end_date);
                                    }
                                  );
                                }}
                                inputProps={{
                                  value: this.state.registration_end_date,
                                  required: true,
                                  placeholder: "Registration End Date",
                                }}
                              />
                            </FormControl>
                          </GridItem>
                        </>
                      ) : null}

                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        style={{ marginTop: "40px" }}
                      >
                        <CustomInput
                          value={this.state.capacity}
                          labelText="Capacity"
                          id="float"
                          inputProps={{
                            value: this.state.capacity,
                            required: true,
                            onChange: (e) =>
                              this.setState({ capacity: e.target.value }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={12}>
                        <br />
                        <label>Description</label>
                        <br />
                        <CKEditor
                          required={true}
                          editor={ClassicEditor}
                          data={
                            this.state.description == null
                              ? ""
                              : this.state.description
                          }
                          // config={editorConfiguration}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            this.setState({
                              description: data,
                              bAlert: false,
                            });
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Google Sheet Details"
                          id="float"
                          inputProps={{
                            value: this.state.googlesheetdetails,
                            onChange: (e) =>
                              this.setState({
                                googlesheetdetails: e.target.value,
                              }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <span
                        style={{
                          marginLeft: "15px",
                          color: "green",
                          fontSize: "13px",
                          fontWeight: "400",
                        }}
                      >
                        {
                          'Sample Link Details: {"sheet_id":"14Tnrl4tTxgVTD-QEKIKsOIgSeAIC0OE1V9-6J37xkUA","sheet_name":"ak"}'
                        }
                      </span>

                      <GridItem xs={12} sm={12} md={6}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? <Loader /> : "Update Batch"}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/batches",
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default UpdateBatch;
